import React from 'react';
import { Alert } from '@mui/material';

import { ArcAlertProps } from './types';

const ArcAlert: React.FC<ArcAlertProps> = ({ sx, ...props }) => {
  return <Alert sx={{ alignItems: 'center', ...sx }} {...props} />;
};

export default ArcAlert;